import { Pipe, PipeTransform } from '@angular/core';
@Pipe({  name: 'orderBya' })
export class OrderrByPipe implements PipeTransform {

    transform(records: Array<any>, args?: any): any {
        return records.sort(function(a, b){
            if(a[args.property] < b[args.property]){
                return -1 * args.direction;
            }
            else if( a[args.property] > b[args.property]){
                return 1 * args.direction;
            }
            else{
                return 0;
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/pipes/orderby-filter.ts